import { type AddressInfoItemFromat } from '@/views/CountryRegion/detail/index'
import styles from './index.module.less'
import copy from 'copy-to-clipboard'
import { message } from 'antd'
import { useTranslation } from 'react-i18next'
import AddressHash from '@/components/AddressHash'
import useMeNavigate from '@/hooks/useMeNavigate'
import MeToolTip from '@/components/MeToolTip'
const DistrictTreasury = ({
  title = 'Title',
  cardInfo = {
    value: '',
    sigin: '',
  },
  address = '',
  tipkey = '',
}: {
  title: string
  cardInfo: AddressInfoItemFromat['value']
  address: string
  tipkey: string
}) => {
  const { t } = useTranslation()
  const navigate = useMeNavigate()
  /**
   * 复制
   */
  const handleCopy = () => {
    copy(address || '')
    message.success(t('explorer_130'))
  }
  return (
    <div className={styles.wrap}>
      <div className="label_wrap">
        <MeToolTip title={title} tip={t(`${tipkey}`)}></MeToolTip>
      </div>
      <div className="content_wrap">
        <div className="content_wrap_left">
          <AddressHash
            data={address}
            copyIcon={'gray'}
            handleJump={() => {
              navigate(`/moduleAccount/${address}`)
            }}
          ></AddressHash>
        </div>
        <div>
          <span className="amount">{cardInfo?.value}</span>
          <span className="unit">{cardInfo?.sigin}</span>
        </div>
      </div>
    </div>
  )
}

export default DistrictTreasury
